import React from 'react';

const ScorpioIcon = ({ width = '80', height = '80', color = '#f1c40f' }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 20V80" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M40 20V80" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M60 20V80" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M80 80L70 70L90 50" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default ScorpioIcon;
